import React from 'react';
import { Box } from '@mui/material';

const Logo = ({ 
  width = 'auto', 
  height = 40, 
  maxWidth = '100%', 
  sx = {},
  onClick,
  variant = 'default', // 'default', 'white', 'dark'
  ...props 
}) => {
  // Apply different filters based on variant
  const getVariantStyles = () => {
    switch (variant) {
      case 'white':
        return { filter: 'brightness(0) invert(1)' }; // Makes logo white
      case 'dark':
        return { filter: 'brightness(0)' }; // Makes logo black
      default:
        return {}; // Original colors
    }
  };

  return (
    <Box
      component="img"
      src="/images/logo/logo.png"
      alt="Company Logo"
      sx={{
        width,
        height,
        maxWidth,
        objectFit: 'contain',
        cursor: onClick ? 'pointer' : 'default',
        transition: 'all 0.3s ease',
        imageRendering: 'optimizeQuality', // Better image rendering
        '&:hover': onClick ? {
          transform: 'scale(1.05)',
          opacity: 0.9
        } : {},
        ...getVariantStyles(),
        ...sx
      }}
      onClick={onClick}
      loading="lazy" // Improve performance
      {...props}
    />
  );
};

export default Logo;
